export enum TimelineState {
  Active = "ACTIVE",
  Past = "PAST",
  Disabled = "DISABLED",
}
